import React from "react";


const StaffRequirementInput = ({value, onChange, isDisabled}) => {
    const handleChange = (e) => {
        const newValue = e.target.value.replace(/[^0-9]/g, '');
        onChange(newValue);
    };

    return (
        <input 
            type="text" 
            value={value}
            onChange={handleChange}
            className="w-full px-3 py-2 text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="0"
            min="0"  
            inputMode="numeric"
            pattern="[0-9]*"
            disabled={isDisabled}
        />
    )
}

export default StaffRequirementInput;